import { useAtomValue } from 'jotai';
import { Trans, useTranslation } from 'react-i18next';
import { useErrorMessage } from '@/core/i18n';
import { InfoTip } from '@/core/ui';
import { rgbCss } from '@/core/utils';
import { WIND_COLOR_STOPS, WIND_RAMP_MAX } from '@/features/stations';
import { useUnitFormatter } from '@/features/units';
import { loadStatusAtom } from '../state/atoms';

const GRADIENT = `linear-gradient(to right, ${WIND_COLOR_STOPS.map(
  ([v, c]) => `${rgbCss(c)} ${(v / WIND_RAMP_MAX) * 100}%`,
).join(', ')})`;

/** What the wind overlay shows, behind an "i" button. */
export function WindHelp() {
  const { t } = useTranslation('forecast');
  return <InfoTip label={t('help.label')}>{t('help.text')}</InfoTip>;
}

/** The speed scale of the wind colours, a load error if any, and the data credit. */
export function WindLegend() {
  const { t } = useTranslation('forecast');
  const fmt = useUnitFormatter();
  const status = useAtomValue(loadStatusAtom);
  const errorMessage = useErrorMessage();

  return (
    <div className="py-2">
      <div className="h-3 rounded-full" style={{ background: GRADIENT }} role="img" aria-label={t('scale')} />
      <div className="mt-1 flex justify-between text-xs text-hint tabular-nums">
        {WIND_COLOR_STOPS.map(([v], k) => (
          <span key={v}>
            {fmt.speedValue(v)}
            {k === WIND_COLOR_STOPS.length - 1 && `+ ${fmt.speedSymbol}`}
          </span>
        ))}
      </div>
      <p className="pt-2 text-sm text-red-700 empty:hidden" role="status">
        {status.kind === 'error' && errorMessage(status.error)}
      </p>
      <p className="pt-2 text-xs text-hint">
        <Trans
          t={t}
          i18nKey="credit"
          components={{
            link: <a className="underline" href="https://open-meteo.com" target="_blank" rel="noreferrer" />,
          }}
        />
      </p>
    </div>
  );
}
